import { calculateBoxSizes } from './algorithms/calculateBoxSize';
class ResizeObserverEntry {
    constructor(target) {
        const boxes = calculateBoxSizes(target);
        this.target = target;
        this.contentRect = boxes.contentRect;
        this.borderBoxSize = boxes.borderBoxSize;
        this.contentSize = boxes.contentBoxSize;
        this.scrollSize = boxes.scrollBoxSize;
        this.devicePixelBorderBoxSize = boxes.devicePixelBorderBoxSize;
    }
}
export { ResizeObserverEntry };
